import styled, { css } from 'styled-components';
import { pxToRem } from '../../../design-tokens/style-utilities';
/**
 * Grid aside
 */
export const gridContainerAsidetyles = () => css `
	order: 1;
`;
export const GridContainerAside = styled.aside `
	${gridContainerAsidetyles}
`;
export const gridContainerAsideContentStyles = ({ theme, $isSticky, $topSpacing, }) => css `
	${$isSticky &&
    css `
		position: sticky;
		top: ${$topSpacing ? $topSpacing : pxToRem(theme.spacing['300'])};
	`}
`;
export const GridContainerAsideContent = styled.div `
	${gridContainerAsideContentStyles}
`;
